export function getEmptySearch(fields = null) {
  const selectList = {}
  const dateList = {}
  const booleanList = {}
  if (!fields) {
    return {
      text: '',
      select: selectList,
      date: dateList,
      boolean: booleanList
    }
  }
  fields
    .filter((data) => 'selectSearch' in data)
    .map((e) => {
      if (e.multiple) {
        selectList[e.key] = []
      } else {
        selectList[e.key] = 'all'
      }
    })
  fields
    .filter((data) => data.dateSearch)
    .map((e) => {
      dateList[e.key] = { after: null, before: null }
    })
  fields
    .filter((data) => data.booleanSearch)
    .map((e) => {
      booleanList[e.key] = 'all'
    })
  return {
    text: '',
    select: selectList,
    date: dateList,
    boolean: booleanList
  }
}

// 検索欄の内容で成果を絞り込む
// TODO:バックグラウンドで検索させるように変える
export function getFilteredArray(datas, fields, search, pagenate) {
  // search: {
  //   text: ''text",
  //   select: [{fieldname1:value},{fieldname1:value}]
  //   date: [{fieldname1:{after: value, before: value}},{fieldname1:{after: value, before: value}}]
  //   boolean: [{fieldname1:value},{fieldname1:value}]
  // }
  const textList = fields.filter((data) => data.textSearch).map((e) => e.key)
  const selectList = fields
    .filter((data) => data.selectSearch)
    .filter((e) => {
      // 複数選択未対応
      return search.select[e.key] !== 'all' && typeof search.select[e.key] !== 'object'
    })
    .map((e) => e.key)
  const dateList = fields
    .filter((data) => data.dateSearch)
    .filter((e) => {
      if (!search.date[e.key]) {
        //  検索用リストが生成途中。一旦表示する
        return true
      }
      if (search.date[e.key].after || search.date[e.key].before) {
        return true
      }
      return false
    })
    .map((e) => e.key)
  // const booleanList = fields.filter(data => data.booleanSearch).map(e => e.key)

  const filteredArray = datas.filter((data) => {
    // セレクトボックスによる一致条件に一つでも合わなければnoMatchにデータが入る
    let noMatch = selectList.some((key) => {
      return String(data[key]) !== String(search.select[key])
      // if (typeof search.select[key] !== 'object') {
      //   return String(data[key]) !== String(search.select[key])
      // }
      // console.log(search.select[key].indexOf(data[key]))
      // console.log(data[key].indexOf(search.select[key]))
      // return search.select[key].indexOf(data[key]) < 0
    })
    if (noMatch) {
      return false
    }

    // 期間の条件が一つでも合わなければnoMatchにデータが入る
    noMatch = dateList.some((key) => {
      if (!data[key]) {
        // 該当データが未設定なら非表示
        return true
      }
      // 比較用に型を揃える
      const date = new Date(data[key])
      if (search.date[key].after && search.date[key].after > date) {
        // 開始条件より古い
        return true
      }
      // TODO:当日が含まれない対策でdate.setDate(date.getDate() - 1)しているが、もっとスマートなやり方に直す
      if (search.date[key].before && search.date[key].before < date.setDate(date.getDate() - 1)) {
        // 終了条件より新しい
        return true
      }
      return false
    })
    if (noMatch) {
      return false
    }

    // 真偽値による条件 TODO:未実装
    // noMatch = booleanList.some(key => {
    //   if (search.boolean[key] === 'all') {
    //     return false
    //   }
    //   if (search.boolean[key] && data[key]) {
    //     return false
    //   }
    //   if (!search.boolean[key] && !data[key]) {
    //     return false
    //   }
    //   return true
    // })
    // if (noMatch) {
    //   return false
    // }

    // 部分一致でテキストがどこかに一致すればOK
    let result = true
    if (search.text) {
      // 全角スペースを半角にしてから、半角スペース区切りで単語を区切る
      const textSearch = search.text.replace(/\u3000/g, ' ').split(' ')
      // 全てのテキストがそれぞれどこかのカラムに含まれればtrue
      result = textSearch.every((text) => {
        // どこかのカラムで一致すればtrue
        return textList.some((field) => {
          if (!data[field]) {
            // フィールドが存在しない = おかしい
            return false
          }
          return data[field].indexOf(text) >= 0
        })
      })
    }
    return result
  })
  return filteredArray.sort((a, b) => {
    const compare = a[pagenate.sortBy] >= b[pagenate.sortBy]
    if (pagenate.sortDesc === compare) {
      return -1
    } else {
      return 1
    }
  })
}

export function getDefaultPagenate(perPage, sortDesc, sortBy) {
  return {
    perPage: perPage || 10, // TODO::後で変える
    currentPage: 1,
    sortDesc: sortDesc === undefined ? true : Boolean(sortDesc),
    sortBy: sortBy || 'updated_at'
  }
}

export default {
  getEmptySearch,
  getFilteredArray,
  getDefaultPagenate
}
